import { HL_USDC_DEPOSIT_ABI } from '@/config/abis/HlUsdcDeposit'
import { HYPERCORE_SPOT_ID } from '@/config/consts'
import { waitForTxReceipt } from '@/utils/waitForTxReceipt'
import { erc20Abi, TransactionReceipt } from 'viem'

export async function depositUSDC(
  walletClient: any,
  publicClient: any,
  tokenAddress: string,
  bridgeContractAddress: string,
  amountInBaseUnits: bigint,
): Promise<TransactionReceipt> {
  const approveTx = await walletClient.writeContract({
    address: tokenAddress,
    abi: erc20Abi,
    functionName: 'approve',
    args: [bridgeContractAddress, amountInBaseUnits],
  })

  await waitForTxReceipt(publicClient, approveTx)

  const depositTx = await walletClient.writeContract({
    address: bridgeContractAddress,
    abi: HL_USDC_DEPOSIT_ABI,
    functionName: 'deposit',
    args: [amountInBaseUnits, HYPERCORE_SPOT_ID],
  })

  const depositReceipt = await waitForTxReceipt(publicClient, depositTx)
  return depositReceipt
}
